import { useTranslation } from "@flare/i18n";

import { TextArea } from "@/components/Funnel/text-area";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";
import { useFunnelAnswers } from "../hooks/useFunnelAnswers";

import type { StepProps } from "./step.types";

export default function AdditionalInfo({ answers, experiments }: StepProps) {
  const { t } = useTranslation();
  const { abTestDivorceFlowEnabled } = experiments;
  const { funnelAnswers } = useFunnelAnswers();
  const { subPractice } = funnelAnswers;
  const { practice } = answers;

  const isAbTestDivorceFlowEnabled =
    abTestDivorceFlowEnabled && subPractice === "divorce";

  // TODO: improve conditional rendering readability
  const inputPlaceholder = isAbTestDivorceFlowEnabled
    ? t("FUNNEL_ADDITIONAL_INFO_FAMILY_PLACEHOLDER_V1")
    : practice === "immigration"
      ? t("FUNNEL_ADDITIONAL_INFO_IMMIGRATION_PLACEHOLDER")
      : t("FUNNEL_ADDITIONAL_INFO_FAMILY_PLACEHOLDER");

  const title = isAbTestDivorceFlowEnabled
    ? t("FUNNEL_ADDITIONAL_INFO_TITLE_V1")
    : t("FUNNEL_ADDITIONAL_INFO_TITLE");

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{title}</StepTitle>
          {isAbTestDivorceFlowEnabled && (
            <StepSubtitle>
              {t("FUNNEL_ADDITIONAL_INFO_FAMILY_SUBTITLE")}
            </StepSubtitle>
          )}
          <div className="mx-auto mt-sp-8 max-w-[520px]">
            <TextArea
              name={funnelInputsNameMap.moreInfo}
              placeholder={inputPlaceholder}
              required
            />
          </div>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
